export enum FormQuestionTypesWithAnswers {
    MultipleChoiceRadio = 1,
    MultipleChoiceCheckBox = 2,
    MultipleChoiceDropDown = 3,
    Matrix = 5,
    MatrixWriteIn = 7,
    MatrixGrouped = 8,
    MatrixMultipleChoice = 9,
    DoubleMatrix = 12
}

export enum BranchableFormQuestionTypes {
    MultipleChoiceRadio = 1,
    MultipleChoiceCheckBox = 2,
    MultipleChoiceDropDown = 3,
    MatrixWriteIn = 7,
}

export enum FormQuestionTypesWithSubQuestions {
    Matrix = 5,
    MatrixWriteIn = 7,
    MatrixGrouped = 8,
    MatrixMultipleChoice = 9,
    DoubleMatrix = 12
}

export enum FormQuestionTypes {
    MultipleChoiceRadio = 1,
    MultipleChoiceCheckBox = 2,
    MultipleChoiceDropDown = 3,
    RatingScale = 4,
    Matrix = 5,
    OpenEnded = 6,
    MatrixWriteIn = 7,
    MatrixGrouped = 8,
    MatrixMultipleChoice = 9,
    Signature = 10,
    SignatureParent = 11,
    DoubleMatrix = 12
}

export enum FormQuestionWriteInTypes {
    Text = 1,
    Date = 2,
    Number = 3,
    Textarea = 4,
    PhoneNumber = 5,
    Email = 6,
    Currency = 7,
    AlphaOnly = 8
}